import React from 'react';

const testimonials = [
  {
    quote:
      'I connected my Moniepoint account on a Tuesday. By Friday I had NGN 1.8M in reorders I would have completely missed.',
    name: 'Adekunle O.',
    role: 'Owner, Lekki Supermarket (4x reorder rate in 21 days)',
  },
  {
    quote:
      'The AI wrote a WhatsApp flow that brought back 68% of customers who hadn’t bought in 30+ days. I’ve never seen anything like this in Nigeria.',
    name: 'Fatima Adebayo',
    role: 'Founder, PalmPay-powered Beauty Store',
  },
  {
    quote:
      'Switched from manual campaigns to Kolanut.ai and my ad spend is down 41% while sales are up 312%. My wife now calls it “the money printer”.',
    name: 'Chinedu Eze',
    role: 'Owner, 3 Nomba POS outlets in Abuja',
  },
  {
    quote:
      'Finally an AI that actually understands Nigerian transaction data and speaks to customers like a real person.',
    name: 'Temi Williams',
    role: 'E-commerce merchant using OPay + WhatsApp',
  },
];

const NgTestimonialsSection = () => {
  return (
    <section id="social-proof" className="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-black mb-3">
            Nigerian merchants are already turning POS data into repeat revenue.
          </h2>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="h-full rounded-3xl border border-gray-200 bg-white px-5 py-5 shadow-sm"
            >
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed mb-3">
                “{t.quote}”
              </p>
              <p className="text-sm font-semibold text-black">{t.name}</p>
              <p className="text-xs text-gray-600 mt-0.5">{t.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NgTestimonialsSection;

